import NeedEmailVerificationModal from './NeedEmailVerificationModal.component';

export default NeedEmailVerificationModal;
